import { render } from "./Configurator.vue?vue&type=template&id=ae68f6b4"
import script from "./Configurator.vue?vue&type=script&lang=js"
export * from "./Configurator.vue?vue&type=script&lang=js"

import "@/assets/scss/views/Configurator.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script